import { render, staticRenderFns } from "./PickupPointList.vue?vue&type=template&id=4e0e8968&scoped=true&"
import script from "./PickupPointList.vue?vue&type=script&lang=js&"
export * from "./PickupPointList.vue?vue&type=script&lang=js&"
import style0 from "./PickupPointList.vue?vue&type=style&index=0&id=4e0e8968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0e8968",
  null
  
)

export default component.exports